import NavBar from '../components/NavBar';
import HomeSection from '../components/Home/HomeSection';
import Footer from '../components/Footer';
import ContactMap from '../components/ContactMap';

const Login = () => {
	return (
		<div className="min-h-screen">
			<NavBar/>
			<HomeSection />
			<ContactMap/>
			<Footer/>
		</div>
	);
};

export default Login;